import indexArray from 'index-array';

import { DuckSelector } from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import inventoryDuck from '@/ducks/inventoryDuck';
import ownersDuck from '@/ducks/ownersDuck';
import { invDuckPreset } from '@/ducks/presets';

import SimilarListingsFetcher from '@/fetchers/SimilarListingsFetcher';

const invSimilarListingsDuck = resultsDuckCreator({
    ...invDuckPreset,
    store: 'similar_listings',
    initialState: {
        activeResults: [],
    },
}).extend({
    creators: () => ({
        getSimilarListings:
        ({ listing }) => async (dispatch, getState) => {
            dispatch(invSimilarListingsDuck.creators.setLoading());

            const { owner = {} } = listing;
            const zip = owner?.location?.address?.zip ?? '';

            const similarListingsCriteria = {
                numRecords: 25,
                zip,
                searchRadius: 100,
                excludedListingId: listing.id,
                makeCode: listing.make?.code,
                modelCode: listing.model?.code,
                classSeriesCode: listing.classSeriesCode,
                trimCode: listing.trim?.code,
                bodyStyleCode: listing.bodyStyles?.[0]?.code,
                extColorSimple: listing.color?.exteriorColorSimple,
                transmissionCode: listing.transmission?.code,
                driveGroup: listing.driveType?.name,
                listingType: listing?.listingType,
                startYear: listing.year - 1,
                endYear: listing.year + 1,
            };

            // remove any undefined properties from request
            Object.keys(similarListingsCriteria).forEach(
                (key) => similarListingsCriteria[key] === undefined && delete similarListingsCriteria[key]
            );

            const response = await SimilarListingsFetcher(similarListingsCriteria);

            if (response?.listings) {
                const { listings, owners } = response;

                const similarListingOwners = indexArray(owners, 'id');

                dispatch(inventoryDuck.creators.addInventory(listings));
                const expandedInventoryIdsArray = listings.map((inventory) => inventory.id);
                dispatch(ownersDuck.creators.addOwners(similarListingOwners));
                dispatch(invSimilarListingsDuck.creators.setActiveResults(expandedInventoryIdsArray));
            } else {
                dispatch(invSimilarListingsDuck.creators.setActiveResults([]));
            }

        },
    }),
    selectors: () => ({
        getInitialLoad: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).initialLoad),
    }),
});

export default invSimilarListingsDuck;
